"use client";

import { c as _c } from "react/compiler-runtime";
import { useId } from "react";
import { Label } from "@defuse/ui/label";
import { ToggleGroup, ToggleGroupItem } from "@defuse/ui/toggle-group";
import type { Source } from "@intents-explorer/shared-api/transactions/transactionsApiV1";
function sourcesToValue(sources: Source[] | undefined) {
  if (sources === undefined) {
    return "swaps";
  }
  if (sources.length === 2) {
    return "all";
  }
  const [first] = sources;
  return first === "masking" ? "masking" : "swaps";
}
export function TransactionTypeFilter(t0) {
  const $ = _c(16);
  const {
    sources,
    updateFilters
  } = t0;
  const labelId = useId();
  let t1;
  if ($[0] !== labelId) {
    t1 = <Label id={labelId} className="text-muted-foreground text-xs">Transaction type</Label>;
    $[0] = labelId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== sources) {
    t2 = sourcesToValue(sources);
    $[2] = sources;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== updateFilters) {
    t3 = value => {
      if (value === "") {
        return;
      }
      if (value === "all") {
        updateFilters({
          source: ["swaps", "masking"]
        });
      } else {
        if (value === "masking") {
          updateFilters({
            source: ["masking"]
          });
        } else {
          updateFilters({
            source: undefined
          });
        }
      }
    };
    $[4] = updateFilters;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  let t5;
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ToggleGroupItem value="swaps" aria-label="Swap transactions">Swaps</ToggleGroupItem>;
    t5 = <ToggleGroupItem value="masking" aria-label="Masking transactions">Masking</ToggleGroupItem>;
    t6 = <ToggleGroupItem value="all" aria-label="All transactions">All</ToggleGroupItem>;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t4 = $[6];
    t5 = $[7];
    t6 = $[8];
  }
  let t7;
  if ($[9] !== labelId || $[10] !== t2 || $[11] !== t3) {
    t7 = <ToggleGroup type="single" variant="outline" value={t2} onValueChange={t3} aria-labelledby={labelId} className="justify-start">{t4}{t5}{t6}</ToggleGroup>;
    $[9] = labelId;
    $[10] = t2;
    $[11] = t3;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t1 || $[14] !== t7) {
    t8 = <div className="flex flex-col justify-center gap-1">{t1}{t7}</div>;
    $[13] = t1;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
}